import * as Xstate from "@xstate/react";
import React from "react";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";

import { ROUTE_NAMES } from "../../app/constants/TextConstants";
import { GlobalContext } from "../../app/stateMachines/GlobalContext";
import { LottieLoading } from "../../components/graphics/LottieLoading";
import { LottieSessionExpired } from "../../components/graphics/LottieSessionExpired";
import { useAppDispatch, useAppSelector } from "../../redux/redux";
import {
  handleDeleteLinkFirm,
  setIsLinkedFirm,
} from "../../services/AppService";
import { getLinkedFirm } from "../../sessionStorage/sessionStorage";
import MainViewPages from "./MainViewPages";
import {
  SESSION_IDLE_SIGN_OUT_MS,
  SESSION_WARNING_MS,
} from "./sessionTimeout.utils";
import { SessionTimeoutWarning } from "./SessionTimeoutWarning";
function clearAllCookies() {
  const Cookies = document.cookie.split(";");
  // set past expiry to all cookies
  for (let i = 0; i < Cookies.length; i++) {
    document.cookie = Cookies[i] + "=; expires=" + new Date(0).toUTCString();
  }
}
export const MainView: React.FC<unknown> = () => {
  // xstate
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { userAuthService, userInfoService } = React.useContext(GlobalContext);
  const [userAuthState] = Xstate.useActor(userAuthService);
  const { userAuthInfo } = userAuthState.context;
  const [userInfoState] = Xstate.useActor(userInfoService);
  const { currentLocation } = userInfoState.context;

  const userEmail = userAuthInfo?.email;
  const locationId = currentLocation?.id;

  const [isSessionExpired, setIsSessionExpired] = React.useState(false);
  const [showTimeoutWarning, setShowTimeoutWarning] = React.useState(false);
  const { user } = useAppSelector((state) => state.appReducer);

  const logout = () => {
    if (getLinkedFirm()) {
      dispatch(
        handleDeleteLinkFirm({ userId: user?.id, orgId: getLinkedFirm()?.id }),
      );
    }
    sessionStorage.clear();
    dispatch(setIsLinkedFirm(false));
    clearAllCookies();
    navigate(ROUTE_NAMES.signOut);
  };

  // Sign out after 1 hour without activity; a warning shows 3 minutes before
  // (Roadmap 1800). While the warning is open, only its buttons keep the
  // session alive.
  const { activate, getRemainingTime } = useIdleTimer({
    crossTab: false,
    timeout: SESSION_IDLE_SIGN_OUT_MS - SESSION_WARNING_MS,
    promptTimeout: SESSION_WARNING_MS,
    debounce: 1000,
    stopOnIdle: true,
    onPrompt: () => setShowTimeoutWarning(true),
    onIdle: () => {
      setShowTimeoutWarning(false);
      logout();
      // setIsSessionExpired(true);
    },
  });

  const handleStaySignedIn = React.useCallback(() => {
    setShowTimeoutWarning(false);
    activate();
  }, [activate]);

  if (isSessionExpired) {
    return (
      <div>
        <LottieSessionExpired />
      </div>
    );
  }

  if (!userEmail) {
    return <LottieLoading />;
  }

  return (
    <>
      <MainViewPages locationId={locationId} />
      {showTimeoutWarning && (
        <SessionTimeoutWarning
          getRemainingTime={getRemainingTime}
          onStaySignedIn={handleStaySignedIn}
          onSignOut={() => {
            setShowTimeoutWarning(false);
            logout();
          }}
        />
      )}
    </>
  );
};
